var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"prev left",on:{"click":function($event){return _vm.$emit('prev')}}},[_c('img',{attrs:{"src":require('@/landings/LE_NEW/sign.svg'),"alt":""}})]),_c('button',{staticClass:"right",on:{"click":function($event){return _vm.$emit('next')}}},[_c('img',{attrs:{"src":require('@/landings/LE_NEW/sign.svg'),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }